import http from "../network/http"
import {random} from "lodash/number"
import polyline from "@mapbox/polyline"
import {round} from "lodash"


export const getTrack = async (route) => {

	let locations = '37.428407,55.695073;'
	for (const point of route.points) {
		locations += point.location[1] + ',' + point.location[0] + ';'
	}
	locations += '37.428407,55.695073'

	const result = await http.get('https://route.ms.ats24.ru/route/v1/driving/' + locations + '?overview=full&annotations=true')
	if (result.data.routes[0]) {
		const data = result.data.routes[0]
		const track = polyline.decode(result.data.routes[0].geometry)
		for (let i = 0; i < track.length; i++) {
			track[i] = {
				location: track[i],
				speed: 0,
				duration: 0
			}
		}

		let x = 0
		let duration = 0

		for (let i = 0; i < data.legs.length; i++) {
			const leg = data.legs[i]
			for (let y = 0; y < leg.annotation.datasources.length; y++) {
				x++
				track[x].speed = round(leg.annotation.speed[y] * 3.6 * (random(0.5, 0.85)), 0)
				track[x].duration = duration + (leg.annotation.duration[y] * 1.5)
				duration += leg.annotation.duration[y] * 1.5

				if (!i && y === leg.annotation.datasources.length - 1) {
					const [h, m] = route.points[0].from.split(':').map(Number)
					route.start_duration = (h * 3600 + m * 60) - duration + random(100, 600)
				}

				// прибытие на точку
				if (y === leg.annotation.datasources.length - 1) {
					// если не дорога на склад
					if (i < data.legs.length - 1) {
						duration += route.points[i].service
					}
				}
			}
		}

		route.start_duration = round(route.start_duration, 0)
		route.finished_duration = round(route.finished_duration, 0)

		// проставляем точкам задержку с учётом старта мл
		for (const point of route.points) {
			point.arrived_duration = round(point.arrived_duration + route.start_duration, 0)
		}

		// проставляем треку задержку с учётом старта мл
		for (const point of track) {
			point.duration = round(point.duration + route.start_duration, 0)
		}

		return track
	}
}

// просчёт маршрутов
/*routes = [...routes]

	for (let route of routes) {
		delete route.started_at
		delete route.finished_at
		let locations = '37.428407,55.695073;'
		for (const point of route.points) {
			locations += point.location[1] + ',' + point.location[0] + ';'
		}
		locations += '37.428407,55.695073'

		const result = await http.get('https://route.ms.ats24.ru/route/v1/driving/' + locations + '?overview=full&annotations=true')
		if (result.data.routes[0]) {
			const data = result.data.routes[0]
			const track = polyline.decode(result.data.routes[0].geometry)
			for (let i = 0; i < track.length; i++) {
				track[i] = {
					location: track[i],
					speed: 0,
					duration: 0
				}
			}

			let x = 0
			let duration = 0

			for (let i = 0; i < data.legs.length; i++) {
				const leg = data.legs[i]
				for (let y = 0; y < leg.annotation.datasources.length; y++) {
					x++
					track[x].speed = round(leg.annotation.speed[y] * 3.6 * (random(0.5, 0.85)), 0)
					track[x].duration = duration + (leg.annotation.duration[y] * 1.5)
					duration += leg.annotation.duration[y] * 1.5

					if (!i && y === leg.annotation.datasources.length - 1) {
						const [h, m] = route.points[0].from.split(':').map(Number)
						route.start_duration = (h * 3600 + m * 60) - duration + random(100, 600)
					}

					// прибытие на точку
					if (y === leg.annotation.datasources.length - 1) {
						// если не дорога на склад
						if (i < data.legs.length - 1) {
							route.points[i].arrived_duration = duration
							duration += route.points[i].service
						} else {
							// дорога на склад, фиксируем время завершения МЛ с учётом старта
							route.finished_duration = route.start_duration + duration
						}

					}
				}
			}

			route.start_duration = round(route.start_duration, 0)
			route.finished_duration = round(route.finished_duration, 0)

			// проставляем точкам задержку с учётом старта мл
			for (const point of route.points) {
				point.arrived_duration = round(point.arrived_duration + route.start_duration, 0)
			}

			// проставляем треку задержку с учётом старта мл
			for (const point of track) {
				point.duration = round(point.duration + route.start_duration, 0)
			}
		}
	}*/

//хуй знает
/*const data = []
	for (const route of routes) {
		route.assigned = []

		let shipments = route.points.map((point, index) => ({
			id: index,
			pickup: {
				id: index,
				location: [37.428407, 55.695073]
			},

			delivery: {
				id: index,
				service: random(120, 550),
				location: [point.location[1], point.location[0]],
				time_windows: [[
					dayjs('2025-06-10 07:00:00').unix(),
					dayjs('2025-06-10 12:00:00').unix()
				]]
			}
		}))

		let vehicles = [{
			id: 0,
			start: [37.428407, 55.695073],
			end: [37.428407, 55.695073],
			speed_factor: 0.8
		}]

		let result = await http.post("https://vrp.ms.ats24.ru", {shipments, vehicles})
		if (result.data.routes?.length) {
			const steps = result.data.routes[0].steps.filter(step => step.type === 'delivery')
			for (let i = 0; i < steps.length; i++) {
				route.assigned.push({...route.points[steps[i].id], ...{position: i + 1, service: steps[i].service}})
			}
		}

		route.points = route.assigned
		delete route.assigned
		data.push(route)
		console.log(data.length)
	}

	console.log(data)*/